export default "__VITE_ASSET__Fv6yuJAQ__"